module.exports = __webpack_public_path__ + "img/prize-04.a1c29d77.png";